import * as Sentry from "@sentry/react"
import { IS_PROD_BUILD } from "../env"

/**
 * Send a chat error to Sentry, tagged `feature: chat` the way the rest of the
 * app tags its captures, so chat errors group together.
 *
 * On prod builds (production and staging) Sentry is the sole path: the console
 * is skipped so we don't double-report — `captureConsoleIntegration` would send
 * the `console.error` on top of the explicit capture. On dev builds Sentry is
 * off, so the console is the only signal and we keep it.
 *
 * Pass the caught `error` when there is one; omit it for a terminal state we
 * reach without one (e.g. giving up after repeated rejections), and the
 * message is captured on its own.
 */
export function reportChatError(message: string, error?: unknown) {
  if (!IS_PROD_BUILD) console.error(`[chat] ${message}`, error ?? "")

  Sentry.setTag("feature", "chat")
  Sentry.captureException(error ?? new Error(`[chat] ${message}`))
}
